var React = require('react');

function Ma (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#c1272d","d":"M640 0H0v480h640z","key":0}),React.createElement("path",{"fill":"none","stroke":"#006233","strokeWidth":"11.7","d":"M320 179.4L284.4 289l93.2-67.6H262.4l93.2 67.6z","key":1})]);
}

Ma.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ma;

Ma.default = Ma;
